import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtmTrackerService } from './services/utm-tracker.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers:[
    UtmTrackerService,
  ]
})
export class UtmTrackerModule { }
